(ns frontend.view.modals.change-password.events
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [frontend.actions.account :as account-actions]
            [potpuri.core :as potpuri]))

(defn reset-state! [state]
  (reset! state {}))

(defn log-error [state args]
  (cond (string/includes? (str args) "Incorrect old password")
        (do
          (swap! state potpuri/dissoc-in [:edit-password :old-pass])
          (swap! state assoc :error-message (loc/tr :incorrect-password)))

        (string/includes? (str args) "Too many tries")
        (do
          (swap! state potpuri/dissoc-in [:edit-password :old-pass])
          (swap! state assoc :error-message (loc/tr :too-many-tries)))

        :else
        (swap! state assoc :error-message (loc/tr :change-password-unknown-error-try-again))))

(defn save-password! [state]
  (account-actions/*->reset-password
   {:old-password (:old-password @state)
    :new-password (:new-pass-1 @state)}
   #(swap! state assoc :password-changed true)
   (partial log-error state)))
